import React, { useEffect } from "react";
import { Box, FormControlLabel, FormGroup, Checkbox, useTheme } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { experienceSteps } from "../../../../Infrastructure/States/educatorStepsSlice";
import { ChoiceTypo, QuestionName } from "../../styles";
import { questionTwoSX } from "./styles";

function QuestionTwo() {
  const theme = useTheme();
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.userData.data);
  const experienceStep = useSelector((state) => state.educatorSteps.experienceStep);
  const questions = userData?.educator?.questions
  const options = [
    { name: "independent", label: "Independent" },
    { name: "tutor", label: "Tutor" },
    { name: "professor", label: "Professor at a college / university" },
    { name: "teacher", label: "Teacher at K-12 School" },
    { name: "experienceOther", label: "Other" },
  ];
  useEffect(() => {
    if (userData && questions && questions?.experience) {
      Object.keys(questions.experience).forEach((key) => {
        const value = questions.experience[key];
        const firstTwoChars = key.substring(0, 2);
        const option = options.find((option) => option.name.substring(0, 2) === firstTwoChars);
        if (option) {
          dispatch(experienceSteps({ name: option.name, checked: value, question: "two" }));
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [questions, dispatch])
  return (
    <Box sx={questionTwoSX.containerBox}>
      <Box sx={questionTwoSX.questionNameBox}>
          <QuestionName variant="h6">
            What teaching roles have you occupied?
          </QuestionName>
        </Box>
        <FormGroup sx={questionTwoSX.formGroup}>
          {options.map((option, index) => (
            <FormControlLabel
              key={index}
              control={
                <Checkbox
                  checked={experienceStep[option.name]}
                  onChange={(e) => {
                    const { name, checked } = e.target;
                    dispatch(
                      experienceSteps({ name, checked, question: "two" })
                    );
                  }}
                  sx={{...questionTwoSX.checkbox, color: theme.palette.primary.main}}
                  name={option.name}
                />
              }
              label={<ChoiceTypo variant="body1">{option.label}</ChoiceTypo>}
              sx={questionTwoSX.formControlLabel}
            />
          ))}
        </FormGroup>
      </Box>
  );
}

export default QuestionTwo;